module.exports = __webpack_public_path__ + "static/img/14000101.6da5377a.png";